export default "__VITE_ASSET__BrXo90h2__"